import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutomationEditorComponent } from './automation-editor.component';

@Component({
  selector: 'automata-automation-editor-preview',
  template: `
    <automata-automation-editor
      [automationId]="id"
      [readOnly]="true"
      [dontCloseNav]="dontCloseNav"
    ></automata-automation-editor>
  `,
  imports: [CommonModule, AutomationEditorComponent],
})
export class AutomationEditorPreviewComponent {
  @Input() id = '';
  @Input() dontCloseNav = false;
}
